import { render, staticRenderFns } from "./FumigationCertificates.vue?vue&type=template&id=462fd9ea"
import script from "./FumigationCertificates.vue?vue&type=script&lang=js"
export * from "./FumigationCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports